import { render } from "./GroupDetail.vue?vue&type=template&id=4bd6a210"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"
script.render = render

export default script